import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../shared/services/config/config.service';
import { HttpClient} from '@angular/common/http';
import urlJoin from 'url-join';
import { ROUTE_TOKEN_GATEWAY_URL } from '../shared/interceptors/gateway-url.interceptor';

@Injectable()
export class SystemManagementService {

  constructor(private configService: ConfigService,
    private http: HttpClient) {
  }

  public revokeAccessToken(): Observable<any> {
    const uri = urlJoin(this._getBaseUrl(), '/payment/v1/system/management/oauthtokens');

    return this.http.delete(uri);
  }

  private _getBaseUrl(): string {
    return ROUTE_TOKEN_GATEWAY_URL;
  }
}
